<template>
  <div>
    <div class="content-top" :class="{ 'nim-management-header': isNIMProject }">
      <div class="flex items-center mb-4 mt-3 justify-between">
        <div class="flex items-center">
          <i class="el-icon-arrow-left font-bold text-xl cursor-pointer" style="color: #999999" @click="goBack" />
          <p class="text-xl ml-2 font-bold" style="color: #ff8e3b">
            {{ project_name }} - Student Registrations <br> {{accountName}}
          </p>
        </div>
      </div>
      <div class="management-toolbar">
        <el-tabs v-if="isNIMProject" v-model="managementTab" class="management-tabs">
          <el-tab-pane label="Manage Students" name="students" />
          <el-tab-pane label="Manage Projects" name="projects" />
        </el-tabs>
        <el-button v-if="isNIMProject && managementTab === 'projects'" @click="$refs.nimProjects.load()">Refresh Projects</el-button>
        <div v-show="managementTab === 'students'" class="student-actions">
        <div style="display: flex; align-items: center; gap: 10px; margin: 0 20px;">
          <label style="color: #606266; font-size: 14px;">Filter by Status:</label>
          <el-select v-model="statusFilter" placeholder="All Statuses" clearable style="width: 150px;" @change="filterByStatus">
            <el-option label="All Statuses" value=""></el-option>
            <el-option label="Paid" value="paid"></el-option>
            <el-option label="Pending Payment" value="pending"></el-option>
            <el-option label="Canceled" value="canceled"></el-option>
          </el-select>
        </div>
        <div style="display: flex;">
          <el-button type="danger" @click="btnCreate">New Registration</el-button>
          <el-button type="warning" @click="btnImport" style="margin-left: 10px;">Import Students</el-button>
          <el-button type="danger" @click="doEditTeam()" v-if="user_type == 'advisor' && project?.project_need_teaming == 'YES'" style="margin-left: 20px;">{{
            enableTeam == false ? 'Assign Teams' : 'Save Teams' }}</el-button>
        </div>
      </div>
    </div>
    </div>
    <NIMProjectManager v-if="isNIMProject && managementTab === 'projects'" ref="nimProjects" :project-id="project_id" />
    <div v-show="managementTab === 'students'">
    <!-- Exclusive Partner Notification -->
    <div v-if="exclusivePartnerData" style="padding: 20px 20px 0 20px;">
      <div style="background: #E6F7FF; border: 1px solid #409EFF; border-radius: 8px; padding: 15px 20px; margin-bottom: 20px;">
        <div style="display: flex; align-items: center; color: #409EFF; font-size: 16px;">
          <i class="el-icon-info" style="margin-right: 10px; font-size: 20px;"></i>
          <span>You are acting as exclusive partner for this program in <strong>{{ exclusivePartnerCountry }}</strong>.</span>
        </div>
      </div>
    </div>
    <!-- Statistics Bar for WEC Projects -->
    <div v-if="isWECProject" style="padding: 20px 20px 0 20px;">
      <div style="background: #FFF3E8; border: 1px solid #FF8E3B; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap; gap: 20px; overflow-x: auto;">
          <div style="text-align: center;">
            <div style="color: #666; font-size: 14px; margin-bottom: 8px;">Current Enrolled Students</div>
            <div style="color: #FF8E3B; font-size: 24px; font-weight: bold;">{{ currentEnrolledCount }}</div>
          </div>
          <div v-if="previousYearParticipantCount !== null" style="text-align: center;">
            <div style="color: #666; font-size: 14px; margin-bottom: 8px;">{{ previousYearWECCode }} Participants</div>
            <div style="color: #FF8E3B; font-size: 24px; font-weight: bold;">{{ previousYearParticipantCount }}</div>
          </div>
          <div v-if="previousYearAverageScore !== null" style="text-align: center;">
            <div style="color: #666; font-size: 14px; margin-bottom: 8px;">{{ previousYearWECCode }} Top 18 Average Score</div>
            <div style="color: #FF8E3B; font-size: 24px; font-weight: bold;">{{ previousYearAverageScore }}</div>
          </div>
          <div style="text-align: center;">
            <div style="color: #666; font-size: 14px; margin-bottom: 8px;">Eligible for Additional Team Spot via Merit Performance Track</div>

            <div v-if="hasMeritData" :style="{ color: meritEligible ? '#67c23a' : '#f56c6c', fontSize: '24px', fontWeight: 'bold' }">
              {{ meritEligible ? 'YES' : 'NO' }}
            </div>
            <div v-else style="color: #999; font-size: 24px; font-weight: bold;">-</div>
          </div>
          <div style="text-align: center;">
            <div style="color: #666; font-size: 14px; margin-bottom: 8px;">Campus Engagement Milestone Verified</div>
            <div v-if="clubEngagementHonorVerified !== null" :style="{ color: clubEngagementHonorVerified ? '#67c23a' : '#f56c6c', fontSize: '24px', fontWeight: 'bold' }">
              {{ clubEngagementHonorVerified ? 'YES' : 'NO' }}
            </div>
            <div v-else style="color: #999; font-size: 24px; font-weight: bold;">-</div>
          </div>
          <div style="text-align: center;">
            <div style="color: #666; font-size: 14px; margin-bottom: 8px;">Maximum Students Can Be Registered</div>
            <div v-if="maxStudentsCanRegister === null" style="color: #67c23a; font-size: 24px; font-weight: bold;">No Restriction</div>
            <div v-else style="color: #FF8E3B; font-size: 24px; font-weight: bold;">{{ maxStudentsCanRegister }}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 20px;">
      <el-table :data="filteredDataList" style="font-size: 12px;box-sizing: border-box;" empty-text="No Data"
        :highlight-current-row="false" :highlight-selection-row="false" :header-cell-class-name="'custom-head-cell'"
        :cell-style="tableCellstyle" :row-class-name="'custom-row-bg'">
        <el-table-column
          label="No."
          width="60"
          align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!--            <el-table-column prop="index" type="index" label="Index" width="100px"></el-table-column>-->
        <el-table-column prop="application_project" label="Student" width="200px">
          <template slot-scope="scope">
            <div class="no-word-break">
              {{ scope.row.student.student_givenName_pinyin.charAt(0).toUpperCase() + scope.row.student.student_givenName_pinyin.slice(1) + ' ' + 
                 scope.row.student.student_lastName_pinyin.charAt(0).toUpperCase() + scope.row.student.student_lastName_pinyin.slice(1) }}
            </div>
            <!-- <div v-if="scope.row.sub_account_nameEN && scope.row.sub_account_nameEN !== ''" style="font-size: 11px; color: #666;">
              ({{ scope.row.sub_account_nameEN }})
            </div> -->
          </template>
        </el-table-column>
        <el-table-column prop="student.student_email" label="Email" width="220px" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="student.student_graduation" label="Grad Year" width="80px"></el-table-column>
        <el-table-column prop="" label="Registered Through" width="160px" v-if="user_type == 'advisor'">
          <template slot-scope="scope">
            {{ scope.row.advisor ? (scope.row.advisor.contact_enName ? 
              scope.row.advisor.contact_enName :
              scope.row.advisor.contact_givenName + ' ' + scope.row.advisor.contact_lastName) :
              'Independent Registration' }}
          </template>
        </el-table-column>
        <el-table-column prop="application_status" label="Status" width="180px">
          <template slot-scope="scope">
            <el-tag
              :type="getStatusType(scope.row.application_status)"
              size="small">
              {{ getStatusLabel(scope.row.application_status) }}
            </el-tag>
            <div v-if="scope.row.application_status === '无需缴费'" style="color: #666; font-size: 11px; margin-top: 4px; line-height: 14px;">
              Fee covered by institution
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="qualification_status" label="Qualification Status" width="170px" v-if="showQualificationStatusColumn">
          <template slot-scope="scope">
            <el-tag :type="getQualificationStatusType(scope.row.qualification_status)" size="small">
              {{ getQualificationStatusLabel(scope.row.qualification_status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="" label="Team" width="150px" v-if="user_type == 'advisor' && project?.project_need_teaming == 'YES'">
          <template slot-scope="scope">
            <el-select v-if="checkEnableEditTeam(scope.row)" v-model="scope.row.application_team_code" :disabled="!checkEnableEditTeam(scope.row)"
              placeholder="Please select team" style="width: 160px;" clearable
              @change="handleApplicationTeamCodeChanged($event, scope.row._id.$id)"
              :class="{'red-bg': !scope.row.application_team_code}">
              <el-option v-for="(code, index) in 12" :key="index" :label="code" :value="code"></el-option>
            </el-select>
            <div v-if="!scope.row.application_team_code && !checkEnableEditTeam(scope.row)">
              <el-tag type="danger" size="small">Not Teamed Yet</el-tag>
              <el-tooltip content="Click 'Assign Teams' to form teams" placement="top">
                <i class="el-icon-info" style="margin-left: 5px; color: #909399;"></i>
              </el-tooltip>
            </div>
            <div v-if="scope.row.application_team_code && scope.row.application_status != '' && !checkEnableEditTeam(scope.row)">
              <el-tag type="info" size="small">in Team {{ scope.row.application_team_code }}</el-tag>
              <div v-if="scope.row.application_team_role === '领队'" style="font-size: 11px; color: #666; margin-top: 2px;">
                Team Leader
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Operation" width="160px">
          
          <template slot-scope="scope">
            <el-button type="primary" @click="editStudentInfo(scope.row)">Edit</el-button>
            <el-dropdown trigger="click" class="action-dropdown">
              <span class="el-dropdown-link">
                <i class="el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item 
                  v-if="scope.row.application_status !== '已取消'"
                  @click.native="btnRemove(scope.row)">
                  <i class="el-icon-delete" style="color: #F56C6C; margin-right: 5px;"></i>
                  Cancel Registration
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="isShowDialog" title="New Registration" width="860px">
      <div>
        <el-form :inline="true" ref="form" :rules="rules" :model="formData" label-width="180px">
          <el-form-item label="Given Name (Native)" prop="givenName">
            <el-input v-model="formData.givenName" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Last Name (Native)" prop="lastName">
            <el-input v-model="formData.lastName" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Given Name (EN)" prop="givenName_pinyin">
            <el-input v-model="formData.givenName_pinyin" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Last Name (EN)" prop="lastName_pinyin">
            <el-input v-model="formData.lastName_pinyin" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input v-model="formData.email" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Year of Graduation" prop="graduation">
            <el-select v-model="formData.graduation" clearable placeholder="Please select" style="width: 220px;">
              <el-option v-for="item in yearOpt" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div style="width: 100%; text-align: center; margin-top: 30px">
          <el-button size="medium" @click="isShowDialog = false">Cancel</el-button>
          <el-button type="primary" size="medium" @click="saveInfo(formData)">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowEditDialog" title="Edit Student Information" width="80%">
      <div>
        <el-form :inline="true" ref="editForm" :rules="editRules" :model="editFormData" label-width="180px">
          <el-form-item label="Given Name (EN)" prop="student_givenName_pinyin">
            <el-input v-model="editFormData.student_givenName_pinyin" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Last Name (EN)" prop="student_lastName_pinyin">
            <el-input v-model="editFormData.student_lastName_pinyin" placeholder="Please input" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="Year of Graduation" prop="student_graduation">
            <el-select v-model="editFormData.student_graduation" clearable placeholder="Please select" style="width: 220px;">
              <el-option v-for="item in yearOpt" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Team Role" prop="application_team_role" v-if="project?.project_need_teaming == 'YES'">
            <el-select v-model="editFormData.application_team_role" clearable placeholder="Please select" style="width: 220px;">
              <el-option label="Team Leader" value="领队"></el-option>
              <el-option label="Team Member" value="队员"></el-option>
            </el-select>
          </el-form-item>
          
        </el-form>
        <div style="margin: 20px; color: #666; font-size: 14px;">
          <i class="el-icon-info" style="color: #409EFF; margin-right: 5px;"></i>
          Advisers currently can only edit students' names and years of graduation. If you want to update your students' other information, you need to contact us via emails or messages in system for manual modification at backend.
        </div>
        <div style="width: 100%; text-align: center; margin-top: 30px">
          <el-button size="medium" @click="isShowEditDialog = false">Cancel</el-button>
          <el-button type="primary" size="medium" @click="saveEditInfo">Save</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowImportDialog" title="Import Students" width="900px" :close-on-click-modal="false">
      <div>
        <div style="margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
          <div>
            <el-button type="primary" size="small" @click="downloadTemplate">
              <i class="el-icon-download"></i> Download Template
            </el-button>
            <span style="color: #999; font-size: 12px; margin-left: 10px;">Please fill in the template and upload</span>
          </div>
          <el-upload
            ref="importUpload"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            accept=".xlsx,.xls"
            :on-change="handleImportFile">
            <el-button type="success" size="small">
              <i class="el-icon-upload2"></i> Select Excel File
            </el-button>
          </el-upload>
        </div>

        <div v-if="importFileName" style="margin-bottom: 10px; color: #409EFF; font-size: 13px;">
          <i class="el-icon-document"></i> {{ importFileName }}
          <span style="margin-left: 10px; color: #67c23a;">{{ importDataList.length }} student(s) found</span>
        </div>

        <el-table v-if="importDataList.length > 0" :data="importDataList" style="font-size: 12px; margin-bottom: 20px;"
          max-height="400" border size="small">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column prop="givenName" label="Given Name (Native)" min-width="120"></el-table-column>
          <el-table-column prop="lastName" label="Last Name (Native)" min-width="120"></el-table-column>
          <el-table-column prop="givenName_pinyin" label="Given Name (EN)" min-width="120"></el-table-column>
          <el-table-column prop="lastName_pinyin" label="Last Name (EN)" min-width="120"></el-table-column>
          <el-table-column prop="email" label="Email" min-width="180"></el-table-column>
          <el-table-column prop="graduation" label="Graduation Year" width="120"></el-table-column>
          <el-table-column label="Status" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row._importStatus === 'success'" type="success" size="mini">Success</el-tag>
              <el-tag v-else-if="scope.row._importStatus === 'fail'" type="danger" size="mini">Failed</el-tag>
              <el-tag v-else-if="scope.row._importStatus === 'importing'" type="warning" size="mini">Importing</el-tag>
              <el-tag v-else-if="scope.row._importError" type="danger" size="mini">{{ scope.row._importError }}</el-tag>
              <el-tag v-else type="info" size="mini">Pending</el-tag>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="importDataList.length > 0" style="text-align: center; margin-top: 20px;">
          <el-button @click="isShowImportDialog = false">Cancel</el-button>
          <el-button type="primary" @click="doImportStudents" :loading="isImporting" :disabled="isImporting">
            {{ isImporting ? `Importing (${importProgress}/${importDataList.length})` : 'Start Import' }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
  </div>
</template>
<script>
import NIMProjectManager from '../../components/NIMProjectManager.vue'
import * as XLSX from 'xlsx'
import {
  batchToUpdateApplicationTeamCode, createApplicationByProjectAndAccount,
  getStudentAppsByAccount, cancelApplication, updateStudentInfo, postRequest,
  updateApplicationTeamRole, getApplicationCountByProjectAndAccount,
  getWECTop18StudentScoreAverage, checkIfBusinessPartner, checkWECClubEngagementHonor
} from '../../api/eae'
import {
  getUserType, getAccountId, getAccountName, getUserId
} from '../../utils/store'

export default ({
  name: 'index',
  components: { NIMProjectManager },
  data() {
    return {
      managementTab: 'students',
      enableTeam: false,
      user_type: getUserType(),
      project_id: this.$route.query.project_id,
      project_code: this.$route.query.project_code,
      project_name: this.$route.query.project_name,
      accountName: getAccountName(),
      dataList: [],
      statusFilter: '',
      year: null,
      yearOpt: [],
      isShowDialog: false,
      project:{},
      formData: {
        project_code: '',
        account_id: '',
        lastName: '',
        givenName: '',
        lastName_pinyin: '',
        givenName_pinyin: '',
        graduation: '',
        email: '',
        student_guardian_first_email: '',
        contact_id: getUserId()
      },
      rules: {
        givenName: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        lastName: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        account_nameEN: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        lastName_pinyin: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        givenName_pinyin: [
          { required: true, message: "Please choose", trigger: "change" },
        ],
        graduation: [
          { required: true, message: "Please choose", trigger: "change" },
        ],
        email: [
          { required: true, message: 'Please input the email', trigger: 'blur' },
          { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }
        ]
      },
      isShowCDialog: false,
      applications_teams: null,
      isShowEditDialog: false,
      editFormData: {
        student_givenName_pinyin: '',
        student_lastName_pinyin: '',
        student_graduation: '',
        application_team_role: '',
        _id: null
      },
      editRules: {
        student_givenName_pinyin: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        student_lastName_pinyin: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        student_email: [
          { required: true, message: 'Please input the email', trigger: 'blur' },
          { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }
        ],
        student_graduation: [
          { required: true, message: "Please choose", trigger: "change" },
        ]
      },
      totalCount: 0,
      previousYearParticipantCount: null,
      previousYearAverageScore: null,
      previousYearWECCode: '',
      exclusivePartnerData: null,
      clubEngagementHonorVerified: null,
      isShowImportDialog: false,
      importDataList: [],
      importFileName: '',
      isImporting: false,
      importProgress: 0,
    }
  },
  computed: {
    isNIMProject() { return String(this.project.project_BU || '').toUpperCase() === 'NIM' },
    filteredDataList() {
      if (!this.statusFilter) {
        return this.dataList
      }
      
      return this.dataList.filter(item => {
        const status = item.application_status
        switch (this.statusFilter) {
          case 'paid':
            return status === '无需缴费' || status === '已缴费'
          case 'pending':
            return status !== '无需缴费' && status !== '已缴费' && status !== '已取消'
          case 'canceled':
            return status === '已取消'
          default:
            return true
        }
      })
    },
    isWECProject() {
      // Check if project_code ends with 'WEC' (case insensitive)
      if (!this.project_code) return false
      return this.project_code.toUpperCase().endsWith('WEC')
    },
    formattedProjectCode() {
      // Extract year from project code and format as YYYYWEC
      if (!this.isWECProject || !this.project_code) return ''
      const match = this.project_code.match(/(\d{4})WEC/i)
      if (match) {
        return match[1] + 'WEC'
      }
      // If no year found, try to extract from project_name or use current year
      const yearMatch = this.project_name?.match(/(\d{4})/)
      if (yearMatch) {
        return yearMatch[1] + 'WEC'
      }
      return new Date().getFullYear() + 'WEC'
    },
    showQualificationStatusColumn() {
      return !!(this.project && this.project.project_need_qualification === 'YES')
    },
    currentEnrolledCount() {
      // Count students that are not canceled
      return this.dataList.filter(item => item.application_status !== '已取消').length
    },
    schoolsCount() {
      // Count unique schools/accounts from the dataList
      // Use sub_account_id, sub_account_nameEN, or account_id to identify unique schools
      const uniqueSchools = new Set()
      this.dataList.forEach(item => {
        // Check for sub_account_id first (nested or direct)
        const subAccountId = item.sub_account_id?._id?.$id || item.sub_account_id?.$id || item.sub_account_id
        const subAccountName = item.sub_account_nameEN
        const accountId = item.account_id?._id?.$id || item.account_id?.$id || item.account_id
        
        if (subAccountId) {
          uniqueSchools.add(subAccountId)
        } else if (subAccountName) {
          // Use name as identifier if ID is not available
          uniqueSchools.add(subAccountName)
        } else if (accountId) {
          uniqueSchools.add(accountId)
        } else {
          // If no sub-account info, count as the main account
          uniqueSchools.add('main_account')
        }
      })
      return uniqueSchools.size || 1 // At least 1 (the current account)
    },
    hasMeritData() {
      return this.previousYearParticipantCount !== null && this.previousYearAverageScore !== null
    },
    meritEligible() {
      return this.hasMeritData && this.previousYearParticipantCount >= 18 && this.previousYearAverageScore > 75
    },
    currentAcademicYear() {
      if (!this.formattedProjectCode) return ''
      const match = this.formattedProjectCode.match(/(\d{4})WEC/i)
      if (!match) return ''
      const year = parseInt(match[1])
      const prev = (year - 1) % 100
      const curr = year % 100
      return `${prev < 10 ? '0' + prev : prev}-${curr < 10 ? '0' + curr : curr}`
    },
    maxStudentsCanRegister() {
      // If exclusive partner provides custom spots, use that directly when valid
      const customSpots = this.exclusivePartnerData?.custom_spots
      if (customSpots && Number(customSpots) > 0) {
        return Number(customSpots)
      }

      // Get base number from project_participant_num
      const baseParticipants = this.project?.project_participant_num

      // If -1, means no restriction
      if (baseParticipants === -1) {
        return null // or 'No restriction' - will be handled in template
      }

      // Use project_participant_num as base, or default to 18 if not available
      const base = baseParticipants && Number(baseParticipants) > 0 ? Number(baseParticipants) : 18

      // Add one team (6) if merit eligible
      let total = base
      if (this.hasMeritData && this.meritEligible) total += 6
      // Add one team (6) if club engagement honor is verified
      if (this.clubEngagementHonorVerified) total += 6
      return total
    },
    exclusivePartnerCountry() {
      if (!this.exclusivePartnerData) return ''
      // Try different possible field names for country
      return this.exclusivePartnerData.country || 
             this.exclusivePartnerData.account_country || 
             this.exclusivePartnerData.partner_country || 
             ''
    }
  },
  mounted() {
    const currentYear = new Date().getFullYear()
    this.yearOpt = []
    for (let i = 0; i < 6; i++) {
      this.yearOpt.push(currentYear + i)
    }
    console.log('project_name : ' + this.project_name)
    console.log(this.$route.query)
    this.fetchData()
    this.getProjectInfo()
    if (this.isWECProject) {
      this.fetchPreviousYearData()
      this.fetchClubEngagementHonor()
    }
    this.checkExclusivePartner()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    filterByStatus() {
      // The filtering is handled by the computed property filteredDataList
    },
    checkEnableEditTeam(application) {
      if (this.enableTeam == false) {
        return false
      }
      if (application.application_status === '无需缴费' || application.application_status === '已缴费') {
        return true
      }
      return false
    },
    doEditTeam() {
      if (this.enableTeam == false) {
        this.enableTeam = true
        this.applications_teams = new Map()
        return
      }
      
      // First, validate team sizes before saving
      if ((this.project.standard_team_size_min || this.project.standard_team_size_max) ) {
        if( !this.validateTeamSizes() ) {
          return; // Stop the save process if validation fails
        }
      }
      
      this.enableTeam = false
      let new_codes = [];
      this.applications_teams.forEach((value, key) => {
        console.log('code : ' + value + ' , id :' + key)
        new_codes.push({
          id: key,
          team_code: value
        })
      });
      if (new_codes.length <= 0) {
        return
      }
      batchToUpdateApplicationTeamCode(new_codes).then((res) => {
        if (res.data && res.data.code < 0) {
          this.$message.error(res.data.msg || 'Team update failed: team size validation error')
        } else {
          this.$message.success('Team updated successful.')
        }
        this.fetchData()
      })
    },
    handleApplicationTeamCodeChanged(code, id) {
      if (this.applications_teams == null) {
        this.applications_teams = new Map()
      }
      this.applications_teams.set(id, code)
    },
    fetchData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getStudentAppsByAccount(getAccountId(), this.project_id, null).then((res) => {
        this.dataList = res.data.data
        this.totalCount = res.data.count || this.dataList.length
        // Sort dataList by application_team_code ascending
        this.dataList.sort((a, b) => {
          // Handle null/undefined team codes by treating them as highest value
          if (!a.application_team_code) return 1;
          if (!b.application_team_code) return -1;
          return a.application_team_code - b.application_team_code;
        });
        loading.close()
      })
    },
    tableCellstyle() {
      return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: Ubuntu-Bold;'
    },
    btnCreate() {
      if (this.maxStudentsCanRegister !== null && this.currentEnrolledCount >= this.maxStudentsCanRegister) {
        this.$message.warning(`Maximum registration limit reached (${this.maxStudentsCanRegister}). You cannot register more students.`)
        return
      }
      this.isShowDialog = true
    },
    saveInfo(data) {
      this.formData.account_id = getAccountId()
      this.formData.project_code = this.project_code
      this.formData.contact_id = getUserId()
      this.$refs.form.validate((val) => {
        if (val) {
          createApplicationByProjectAndAccount({ ...this.formData, from: 'adviser' }).then((res) => {
            if (res.data && res.data._id && res.data._id.$id) {
              this.fetchData()
              this.$message.success("Registration Successful");
              this.formData = {
          
                  lastName: '',
                  givenName: '',
                  lastName_pinyin: '',
                  givenName_pinyin: '',
                  graduation: '',
                  email: '',
                  
                  
              };
            } else {
              this.$message.error(res.data?.msg || "Registration Failed");
            }
            /*this.$router.replace({
              path: '/form/success',
              query: {
                id: res.data._id.$id,
                project: 'registration'
              }
            })*/
            this.isShowDialog = false
          });
        }
      });
    },
    btnRemove(data) {
      this.$confirm(
        'Are you sure you want to cancel the registration of ' + data.student.student_givenName_pinyin.charAt(0).toUpperCase() + data.student.student_givenName_pinyin.slice(1) + ' ' + data.student.student_lastName_pinyin.charAt(0).toUpperCase() + data.student.student_lastName_pinyin.slice(1) + ' from the ' + data.application_project + '？',
        "Think twice",
        {
          type: "warning",
          confirmButtonText: "Do Cancel",
        }
      ).then(() => {
        cancelApplication(data._id.$id).then((res) => {
          this.$message.success('Registration cancelled successfully')
          this.fetchData()
        })
      }).catch(() => { });
    },
    editStudentInfo(row) {
      this.editFormData = {
        student_givenName_pinyin: row.student.student_givenName_pinyin,
        student_lastName_pinyin: row.student.student_lastName_pinyin,
        student_graduation: row.student.student_graduation,
        application_team_role: row.application_team_role || '',
        _id: row._id.$id
      }
      this.isShowEditDialog = true
    },
    saveEditInfo() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // Find and update the student in dataList
          const index = this.dataList.findIndex(item => item._id.$id === this.editFormData._id)
          if (index !== -1) {
            this.dataList[index].student.student_givenName_pinyin = this.editFormData.student_givenName_pinyin
            this.dataList[index].student.student_lastName_pinyin = this.editFormData.student_lastName_pinyin
            this.dataList[index].student.student_graduation = this.editFormData.student_graduation
            this.dataList[index].application_team_role = this.editFormData.application_team_role

            
            // Update student info in backend
            const studentData = {
              student_id: this.dataList[index].student._id.$id,
              student_lastName_pinyin: this.dataList[index].student.student_lastName_pinyin,
              student_givenName_pinyin: this.dataList[index].student.student_givenName_pinyin,
              student_graduation: this.dataList[index].student.student_graduation,
              
            }

            Promise.all([
              updateStudentInfo(studentData),
              updateApplicationTeamRole(this.editFormData._id, this.editFormData.application_team_role)
            ]).then(responses => {
              const [studentRes, teamRoleRes] = responses
              if (studentRes.data.code === 0 && teamRoleRes.data.code === 0) {
                // Backend update successful
                this.$message.success('Student information updated successfully')
                this.isShowEditDialog = false
              } else {
                this.$message.error('Failed to update student info in backend')
              }
            }).catch(err => {
              console.error('Error updating student info:', err)
              this.$message.error('Error updating student info') 
            })

            
          }
        }
      })
    },
    getStatusType(status) {
      switch (status) {
        case '无需缴费':
        case '已缴费':
          return 'success';
        case '已取消':
          return 'info';
        default:
          return 'warning';
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case '无需缴费':
          return 'No Payment Required'
        case '已缴费':
          return 'Paid'
        case '已取消':
          return 'Canceled'
        default:
          return 'Pending Payment'
      }
    },
    getQualificationStatusType(status) {
      return status === 'qualified' ? 'success' : 'warning'
    },
    getQualificationStatusLabel(status) {
      if (status === 'qualified') return 'Qualified'
      if (status === 'none') return 'Not Required'
      return 'Pending Qualification'
    },
    getProjectInfo() {
      postRequest({
        function: 'getProjectInfoById',
        project_id: this.project_id
      }).then(res => {
        if (res.data) {
          this.project = res.data;
          console.log('Project info loaded:', this.project);
        } else {
          this.$message.warning('Could not load project information');
        }
      }).catch(err => {
        console.error('Error fetching project info:', err);
        this.$message.error('Failed to load project information');
      });
    },
    // Add this new method for team size validation
    validateTeamSizes() {
      // Get team size limits from project
      const minTeamSize = this.project.standard_team_size_min? this.project.standard_team_size_min: null; // Default to 3 if not specified
      const maxTeamSize = this.project.standard_team_size_max? this.project.standard_team_size_max: null; // Default to 6 if not specified
      
      // Create a map to count students in each team
      const teamCounts = new Map();
      
      // Count current team members from dataList
      this.dataList.forEach(student => {
        if (student.application_status === '无需缴费' || student.application_status === '已缴费') {
          const teamCode = student.application_team_code;
          if (teamCode) {
            teamCounts.set(teamCode, (teamCounts.get(teamCode) || 0) + 1);
          }
        }
      });
      
      // Apply pending team changes from this.applications_teams
      if (this.applications_teams && this.applications_teams.size > 0) {
        this.applications_teams.forEach((newTeamCode, studentId) => {
          // Find the student's current team code
          const student = this.dataList.find(s => s._id.$id === studentId);
          if (student) {
            const oldTeamCode = student.application_team_code;
            
            // Remove from old team count if applicable
            if (oldTeamCode && teamCounts.has(oldTeamCode)) {
              teamCounts.set(oldTeamCode, teamCounts.get(oldTeamCode) - 1);
              // Remove team if count is zero
              if (teamCounts.get(oldTeamCode) <= 0) {
                teamCounts.delete(oldTeamCode);
              }
            }
            
            // Add to new team count if applicable
            if (newTeamCode) {
              teamCounts.set(newTeamCode, (teamCounts.get(newTeamCode) || 0) + 1);
            }
          }
        });
      }
      
      // Check if any team violates size constraints
      let validationPassed = true;
      const invalidTeams = [];
      
      teamCounts.forEach((count, teamCode) => {
        if ((minTeamSize != null && count < minTeamSize) || (maxTeamSize != null && count > maxTeamSize)) {
          invalidTeams.push({
            team: teamCode,
            count: count,
            issue: count < minTeamSize ? 'too small' : 'too large'
          });
          validationPassed = false;
        }
      });
      
      // Show error message if validation fails
      if (!validationPassed) {
        let errorMsg = 'Invalid teams:\n\n';
        if (minTeamSize != null && maxTeamSize != null) {
          errorMsg = `Team size must be between ${minTeamSize} and ${maxTeamSize} students.\n\nInvalid teams:\n`;
        } else if (minTeamSize != null) {
          errorMsg = `Team size must be at least ${minTeamSize} students.\n\nInvalid teams:\n`; 
        } else if (maxTeamSize != null) {
          errorMsg = `Team size must not exceed ${maxTeamSize} students.\n\nInvalid teams:\n`;
        }
        
        invalidTeams.forEach(team => {
          errorMsg += `- Team ${team.team}: ${team.count} students (${team.issue})\n`;
        });
        
        this.$confirm(errorMsg, 'Team Size Validation Failed', {
          confirmButtonText: 'Adjust Teams',
          
          type: 'warning'
        }).then(() => {
          // User clicked "Adjust Teams" - keep the edit mode active
          this.enableTeam = true;
        }).catch(() => {
          // User clicked "Continue Editing" - keep the edit mode active
          this.enableTeam = true;
        });
      }
      
      return validationPassed;
    },
    fetchPreviousYearData() {
      // Calculate previous year's WEC project code
      if (!this.formattedProjectCode) return
      
      const yearMatch = this.formattedProjectCode.match(/(\d{4})WEC/i)
      if (!yearMatch) return
      
      const currentYear = parseInt(yearMatch[1])
      const previousYear = currentYear - 1
      this.previousYearWECCode = previousYear + 'WEC'
      
      // Fetch participant count and average score for previous year
      const accountId = getAccountId()
      if (!accountId) return
      
      // Fetch participant count
      getApplicationCountByProjectAndAccount(this.previousYearWECCode, accountId)
        .then((res) => {
          if (res.data && res.data.code === 0 && res.data.data !== undefined) {
            // Backend returns message(0, $count, ...) so data is in res.data.data
            this.previousYearParticipantCount = res.data.data
          } else if (res.data && typeof res.data === 'number') {
            this.previousYearParticipantCount = res.data
          } else {
            this.previousYearParticipantCount = 0
          }
        })
        .catch((err) => {
          console.error('Error fetching previous year participant count:', err)
          this.previousYearParticipantCount = 0
        })
      
      // Fetch average score
      getWECTop18StudentScoreAverage(this.previousYearWECCode, accountId)
        .then((res) => {
          if (res.data && res.data.code === 0 && res.data.data !== undefined) {
            // Backend returns message(0, $average_score, ...) so data is in res.data.data
            this.previousYearAverageScore = res.data.data
          } else if (res.data && typeof res.data === 'number') {
            this.previousYearAverageScore = res.data
          } else {
            this.previousYearAverageScore = null
          }
        })
        .catch((err) => {
          console.error('Error fetching previous year average score:', err)
          this.previousYearAverageScore = null
        })
    },
    fetchClubEngagementHonor() {
      const accountId = getAccountId()
      if (!accountId || !this.currentAcademicYear) return

      checkWECClubEngagementHonor(accountId, this.currentAcademicYear)
        .then((res) => {
          if (res.data && res.data.code === 0) {
            this.clubEngagementHonorVerified = !!res.data.data
          } else {
            this.clubEngagementHonorVerified = false
          }
        })
        .catch((err) => {
          console.error('Error checking club engagement honor:', err)
          this.clubEngagementHonorVerified = false
        })
    },
    btnImport() {
      if (this.maxStudentsCanRegister !== null && this.currentEnrolledCount >= this.maxStudentsCanRegister) {
        this.$message.warning(`Maximum registration limit reached (${this.maxStudentsCanRegister}). You cannot register more students.`)
        return
      }
      this.importDataList = []
      this.importFileName = ''
      this.importProgress = 0
      this.isImporting = false
      this.isShowImportDialog = true
    },
    downloadTemplate() {
      const headers = [
        ['Given Name (Native)', 'Last Name (Native)', 'Given Name (EN)', 'Last Name (EN)', 'Email', 'Graduation Year']
      ]
      const ws = XLSX.utils.aoa_to_sheet(headers)
      ws['!cols'] = [
        { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 30 }, { wch: 15 }
      ]
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Students')
      XLSX.writeFile(wb, 'Student_Import_Template.xlsx')
    },
    handleImportFile(file) {
      this.importFileName = file.name
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const sheetName = workbook.SheetNames[0]
          const sheet = workbook.Sheets[sheetName]
          const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' })

          if (jsonData.length === 0) {
            this.$message.warning('The file is empty')
            return
          }

          // Map columns - support both English headers and Chinese headers
          this.importDataList = jsonData.map(row => {
            const mapped = {
              givenName: String(row['Given Name (Native)'] || row['姓（母语）'] || row['名'] || '').trim(),
              lastName: String(row['Last Name (Native)'] || row['名（母语）'] || row['姓'] || '').trim(),
              givenName_pinyin: String(row['Given Name (EN)'] || row['名（英文）'] || row['英文名'] || '').trim(),
              lastName_pinyin: String(row['Last Name (EN)'] || row['姓（英文）'] || row['英文姓'] || '').trim(),
              email: String(row['Email'] || row['邮箱'] || row['电子邮箱'] || '').trim(),
              graduation: String(row['Graduation Year'] || row['毕业年份'] || row['graduation'] || '').trim(),
              _importStatus: '',
              _importError: ''
            }

            // Validate required fields
            if (!mapped.givenName_pinyin || !mapped.lastName_pinyin || !mapped.email || !mapped.graduation) {
              mapped._importError = 'Missing required fields'
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mapped.email)) {
              mapped._importError = 'Invalid email'
            }

            return mapped
          })

          const errorCount = this.importDataList.filter(r => r._importError).length
          if (errorCount > 0) {
            this.$message.warning(`${errorCount} row(s) have validation errors, please check`)
          }
        } catch (err) {
          console.error('Error parsing Excel:', err)
          this.$message.error('Failed to parse the Excel file')
        }
      }
      reader.readAsArrayBuffer(file.raw)
    },
    async doImportStudents() {
      const validList = this.importDataList.filter(r => !r._importError)
      if (validList.length === 0) {
        this.$message.warning('No valid data to import')
        return
      }

      // Check max registration limit
      if (this.maxStudentsCanRegister !== null) {
        const remaining = this.maxStudentsCanRegister - this.currentEnrolledCount
        if (validList.length > remaining) {
          this.$message.warning(`Only ${remaining} more student(s) can be registered. You are trying to import ${validList.length}.`)
          return
        }
      }

      this.isImporting = true
      this.importProgress = 0
      let successCount = 0
      let failCount = 0

      for (let i = 0; i < this.importDataList.length; i++) {
        const row = this.importDataList[i]
        if (row._importError) {
          failCount++
          this.importProgress++
          continue
        }

        this.$set(this.importDataList, i, { ...row, _importStatus: 'importing' })

        try {
          const params = {
            project_code: this.project_code,
            account_id: getAccountId(),
            contact_id: getUserId(),
            givenName: row.givenName,
            lastName: row.lastName,
            givenName_pinyin: row.givenName_pinyin,
            lastName_pinyin: row.lastName_pinyin,
            email: row.email,
            graduation: row.graduation,
            from: 'adviser'
          }
          const res = await createApplicationByProjectAndAccount(params)
          if (res.data._id && res.data._id.$id) {
            this.$set(this.importDataList, i, { ...this.importDataList[i], _importStatus: 'success' })
            successCount++
          } else {
            this.$set(this.importDataList, i, { ...this.importDataList[i], _importStatus: 'fail', _importError: res.data.msg || 'Failed' })
            failCount++
          }
        } catch (err) {
          const errorMsg = err.response?.data?.msg || err.message || 'Error'
          this.$set(this.importDataList, i, { ...this.importDataList[i], _importStatus: 'fail', _importError: errorMsg })
          failCount++
        }
        this.importProgress++
      }

      this.isImporting = false
      this.$message.success(`Import completed: ${successCount} success, ${failCount} failed`)
      this.fetchData()
    },
    checkExclusivePartner() {
      const accountId = getAccountId()
      if (!accountId || !this.project_code) return
      
      checkIfBusinessPartner(this.project_code, accountId)
        .then((res) => {
          if (res.data && res.data.code === 0 && res.data.data) {
            // Backend returns message(0, $data, ...) so data is in res.data.data
            this.exclusivePartnerData = res.data.data
          } else {
            this.exclusivePartnerData = null
          }
        })
        .catch((err) => {
          console.error('Error checking exclusive partner:', err)
          this.exclusivePartnerData = null
        })
    },
  }
})
</script>
<style lang="scss" scoped>
/* Method 1: Using ::v-deep */


/* Method 4: Remove scoped and use more specific selectors */

.content-top {
  align-items: center;
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 0 20px;
}

.action-dropdown {
  margin-left: 16px;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 20px;
  color: #606266;
}

.el-dropdown-link:hover {
  color: #409EFF;
}

/deep/ .red-bg {
  color: red;  /* This will make the text red instead of the background */
}

/* Or if you specifically want to target Element UI table cell content */
/deep/ .el-table__row {
  .red-bg {
    color: red;
  }
}

.no-word-break {
  word-break: keep-all;  /* Prevent breaking words */
  white-space: normal;   /* Allow wrapping at spaces */
  hyphens: none;         /* Disable hyphenation */
}
</style>

<style>
.el-table__row.red-bg,
.el-table__row.red-bg td,
.el-table__row.red-bg:hover td {
  background-color: red !important;
}
</style>

<style scoped>
.nim-management-header { display:block; }
.management-toolbar { display:flex; align-items:center; flex-wrap:wrap; gap:12px 24px; margin:12px 20px 0; }
.management-tabs { flex:0 0 auto; } .management-tabs >>> .el-tabs__header { margin:0; }
.student-actions { display:flex; flex:1; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
</style>
